export const ERROR_BOUNDARY_REDIRECT_PATH = "errorBoundaryRedirectPath";
export const SKIP_ARCHIVE_RESTORE_CONFIRMATION_KEY = "skipArchiveRestoreConfirmation";

/**
 * Save data to localStorage
 * @param {string} key - The key to store data under
 * @param {any} value - The value to store
 * @returns {void}
 */
export const setLocalStorage = (key, value) => {
  try {
    const serializedValue = typeof value === "object" ? JSON.stringify(value) : value;
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error("Error setting localStorage:", error);
  }
};

/**
 * Retrieve data from localStorage
 * @param {string} key - The key to retrieve data from
 * @param {any} defaultValue - Default value if key doesn't exist
 * @returns {any} The stored value or defaultValue if not found
 */
export const getLocalStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    if (item === null) return defaultValue;

    // Try to parse as JSON, return as is if not valid JSON
    try {
      return JSON.parse(item);
    } catch {
      return item;
    }
  } catch (error) {
    console.error("Error getting localStorage:", error);
    return defaultValue;
  }
};

/**
 * Remove data from localStorage
 * @param {string} key - The key to remove
 * @returns {void}
 */
export const removeLocalStorage = key => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing localStorage:", error);
  }
};

/**
 * Clear all data from localStorage
 * @returns {void}
 */
export const clearLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error("Error clearing localStorage:", error);
  }
};

/**
 * LocalStorage utility function dictionary
 */
export const localStorageUtils = {
  set: setLocalStorage,
  get: getLocalStorage,
  remove: removeLocalStorage,
  clear: clearLocalStorage,
};

/**
 * Save data to sessionStorage
 * @param {string} key - The key to store data under
 * @param {any} value - The value to store
 * @returns {void}
 */
export const setSessionStorage = (key, value) => {
  try {
    const serializedValue = typeof value === "object" ? JSON.stringify(value) : value;
    sessionStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error("Error setting sessionStorage:", error);
  }
};

/**
 * Retrieve data from sessionStorage
 * @param {string} key - The key to retrieve data from
 * @param {any} defaultValue - Default value if key doesn't exist
 * @returns {any} The stored value or defaultValue if not found
 */
export const getSessionStorage = (key, defaultValue = null) => {
  try {
    const item = sessionStorage.getItem(key);
    if (item === null) return defaultValue;

    // Try to parse as JSON, return as is if not valid JSON
    try {
      return JSON.parse(item);
    } catch {
      return item;
    }
  } catch (error) {
    console.error("Error getting sessionStorage:", error);
    return defaultValue;
  }
};

/**
 * Remove data from sessionStorage
 * @param {string} key - The key to remove
 * @returns {void}
 */
export const removeSessionStorage = key => {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing sessionStorage:", error);
  }
};

/**
 * Clear all data from sessionStorage
 * @returns {void}
 */
export const clearSessionStorage = () => {
  try {
    sessionStorage.clear();
  } catch (error) {
    console.error("Error clearing sessionStorage:", error);
  }
};

/**
 * SessionStorage utility function dictionary
 */
export const sessionStorageUtils = {
  set: setSessionStorage,
  get: getSessionStorage,
  remove: removeSessionStorage,
  clear: clearSessionStorage,
};

export default localStorageUtils;
